var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.177734 2.5478V9.94494C0.177734 10.7861 0.509245 11.5926 1.10299 12.1863L9.81133 20.8947C11.0483 22.1317 13.0522 22.1317 14.2892 20.8947L20.8947 14.2892C22.1316 13.0522 22.1316 11.0483 20.8947 9.81135L12.1863 1.10301C11.5926 0.509262 10.7861 0.177752 9.94492 0.177752H2.55273C1.24154 0.172804 0.177734 1.23661 0.177734 2.5478ZM5.7194 4.13114C6.13933 4.13114 6.54205 4.29795 6.83899 4.59488C7.13592 4.89182 7.30273 5.29454 7.30273 5.71447C7.30273 6.1344 7.13592 6.53712 6.83899 6.83406C6.54205 7.13099 6.13933 7.2978 5.7194 7.2978C5.29947 7.2978 4.89675 7.13099 4.59981 6.83406C4.30288 6.53712 4.13607 6.1344 4.13607 5.71447C4.13607 5.29454 4.30288 4.89182 4.59981 4.59488C4.89675 4.29795 5.29947 4.13114 5.7194 4.13114Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBogo);
export default __webpack_public_path__ + "static/media/bogo.1a42bf95bee8493f09f2a32a643dbdfb.svg";
export { ForwardRef as ReactComponent };